export default "__VITE_ASSET__BVOCkzIW__"